import { useEffect, useState } from "react";
import { Globe, MessageCircle, Instagram, Facebook, Twitter, Youtube, Linkedin } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { cn } from "@/lib/utils";

export interface SocialLink { name: string; href: string; icon: string; }

const TikTok = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.6 6.7a4.8 4.8 0 0 1-3.8-4.2V2h-3.4v13.6a2.9 2.9 0 1 1-2-2.7V9.4a6.3 6.3 0 1 0 5.4 6.2V8.7a8.2 8.2 0 0 0 3.8 1.2V6.7z" />
  </svg>
);

export const SOCIAL_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  whatsapp: MessageCircle, instagram: Instagram, facebook: Facebook, tiktok: TikTok,
  twitter: Twitter, youtube: Youtube, linkedin: Linkedin, globe: Globe,
};

let cache: SocialLink[] | null = null;
let pending: Promise<SocialLink[]> | null = null;
export const useSocials = () => {
  const [s, setS] = useState<SocialLink[]>(cache ?? []);
  useEffect(() => {
    if (cache) return;
    pending ??= Promise.resolve(
      supabase.from("footer_settings").select("socials").eq("id", 1).maybeSingle()
    ).then(({ data }) => (cache = ((data?.socials as unknown) as SocialLink[]) ?? []));
    pending.then(setS).catch(() => {});
  }, []);
  return s;
};

const SocialIcons = ({ className, itemClassName }: { className?: string; itemClassName?: string }) => {
  const socials = useSocials();
  if (!socials.length) return null;
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {socials.map((s, i) => {
        const Icon = SOCIAL_ICONS[s.icon?.toLowerCase()] ?? Globe;
        return (
          <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.name}
            className={cn("w-8 h-8 rounded-full flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-muted transition-colors", itemClassName)}>
            <Icon className="w-4 h-4" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
